import { render, staticRenderFns } from "./modalExcluir.vue?vue&type=template&id=c6e4d5f2&scoped=true&"
import script from "./modalExcluir.vue?vue&type=script&lang=js&"
export * from "./modalExcluir.vue?vue&type=script&lang=js&"
import style0 from "./modalExcluir.vue?vue&type=style&index=0&id=c6e4d5f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6e4d5f2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCol,VContainer,VDialog,VRow})
